import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errDetail } from "@agent/lib/api";
import { LinkedinSettingsCard } from "@agent/components/LinkedinSettingsCard";
import { WebsitePublisherCard, ManualPostingCard } from "@agent/components/WebsitePublisherCard";

export default function Settings() {
  const [status, setStatus] = useState(null);
  const [webStatus, setWebStatus] = useState(null);
  const [orgId, setOrgId] = useState("");
  const [params, setParams] = useSearchParams();

  const load = () => {
    api.get("/linkedin/status").then((r) => { setStatus(r.data); if (r.data.org_id) setOrgId(r.data.org_id); }).catch((e) => toast.error(errDetail(e)));
    api.get("/website/status").then((r) => setWebStatus(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
    const li = params.get("linkedin");
    if (li === "connected") { toast.success("LinkedIn Page connected"); setParams({}); }
    else if (li === "error") { toast.error(`LinkedIn connection failed: ${params.get("reason") || "unknown"}`); setParams({}); }
    // Runs once on mount only to read the OAuth redirect query params; re-running on every
    // `params` change would re-fire the toast after setParams({}) clears the query string.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const connect = async () => {
    try {
      const { data } = await api.get("/linkedin/auth-url");
      window.location.href = data.url;
    } catch (e) {
      toast.error(errDetail(e));
    }
  };

  const disconnect = async () => {
    try {
      await api.post("/linkedin/disconnect");
      toast.success("Disconnected");
      load();
    } catch (e) {
      toast.error(errDetail(e));
    }
  };

  const saveOrg = async () => {
    try {
      const { data } = await api.put("/linkedin/org", { org_id: orgId });
      setOrgId(data.org_id);
      toast.success("Organization ID saved");
      load();
    } catch (e) {
      toast.error(errDetail(e));
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-6">
      <div>
        <span className="inline-block px-3 py-1 rounded-full border border-slate-200 bg-white text-[11px] tracking-[0.15em] uppercase text-slate-500 font-semibold mb-4 shadow-sm">Publisher config</span>
        <h1 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#0f172a]">
          Settings. <span className="grad-text">Wired for publishing.</span>
        </h1>
      </div>

      <LinkedinSettingsCard status={status} orgId={orgId} setOrgId={setOrgId}
        onConnect={connect} onDisconnect={disconnect} onSaveOrg={saveOrg} />
      <WebsitePublisherCard webStatus={webStatus} />
      <ManualPostingCard />
    </div>
  );
}
